import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import { markBootCommitted } from "./bootSafety";

// The splash is dismissed exactly once, the first time the UI is actually on screen
// (the first native view's routes commit, see routes.tsx). launchAutoHide is false,
// so nothing else hides it. App() re-renders ~20 times during launch (once per native
// view under capacitor-native-navigation), so the guard must be module-level, not
// per-render.
let splashHidden = false;

/**
 * Hide the native splash, once. No-op on web/Android-without-splash and on repeat
 * calls. Call this when the first real view has mounted, not merely when app state
 * is "ready": under native navigation the view can mount many seconds after
 * i18n/store hydration finish.
 *
 * This is also the boot's commit signal: reaching here means the module graph
 * imported, React committed, and a real view is on screen, which is exactly what
 * bootSafety's escalating recovery stops caring about.
 */
export function hideSplashOnce(): void {
  if (splashHidden) return;
  markBootCommitted();
  if (!Capacitor.isNativePlatform()) return;
  splashHidden = true;
  void SplashScreen.hide();
}
